import * as API from '@/api'
import request from './index'

//无分页厂区
export function getListNp(params = {}) {
    return request.get(API.FAC_LIST_NP, {
        params
    })
}
//获取厂区列表
export function getList(params) {
    return request.get(API.FAC_LIST, {
        params
    })
}

//添加厂区
export function add(data) {
    return request.post(API.FAC_ADD, data)
}

//修改厂区
export function edit(data) {
    return request.post(API.FAC_EDIT, data)
}

//删除厂区
export function del(id) {
    return request.get(API.FAC_DEL, {
        params: {
            id
        }
    })
}
